import { h } from "@stencil/core";
const RegionItem = ({ active, baseClass, onSelect, region }) => {
    const { country, label, prefix } = region;
    return (h("li", { class: {
            [`${baseClass}__option`]: true,
            // @ts-expect-error Check for typing
            ["is-active"]: active
        }, onClick: () => onSelect(country), role: "option", "aria-selected": active }, h("ux-country-icon", { country: country, size: "s" }), label, prefix && ` (+${prefix})`));
};
export default RegionItem;
//# sourceMappingURL=region-item.js.map
